import React from "react";
import SideBarChat from "./SideBarChat";

function MessageLeftSection(props) {
  const {
    messages,
    introductionsArray,
    selectedIntroductionId,
    userId,
    handleWantAdSelection,
    introIdFromURL,
    fromDM,
  } = props;

  // Ensure messages is always an array
  const messagesArray = Array.isArray(messages) ? messages : [];

  // If introductionsArray exists and has data, filter messages
  const filteredMessages =
    introductionsArray && introductionsArray.length > 0
      ? messagesArray
          .filter((msg) => introductionsArray.includes(msg.IntroductionId))
          .slice(0, 1) // Show only the first match
      : messagesArray;

  // If introductionsArray is an empty array and fromDM is true, show "No messages available"
  if (
    Array.isArray(introductionsArray) &&
    introductionsArray.length === 0 &&
    fromDM
  ) {
    return <p>No messages available</p>;
  }

  return (
    <>
      {filteredMessages.length > 0 ? (
        <div className="messaging-top-content">
          {filteredMessages.map((msg, index) => (
            <SideBarChat
              key={msg.IntroductionId}
              id={msg.IntroductionId}
              msgData={msg}
              index={index}
              selectedIntroductionId={selectedIntroductionId}
              userId={userId}
              handleWantAdSelection={handleWantAdSelection}
              introIdFromURL={introIdFromURL}
              introductionsArray={introductionsArray}
              fromDM={fromDM}
            />
          ))}
        </div>
      ) : (
        <p>No messages available</p>
      )}
    </>
  );
}

export default MessageLeftSection;
